import React from "react";
import SignUp from "../components/SignUp";
import Footer from "../components/UI/Footer";

export default function Register() {
    return (
        <>
            <SignUp />
            <Footer />
        </>
    );
}
